import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ArchwizardModule } from 'angular-archwizard';
import { GalleryModule } from '@ks89/angular-modal-gallery';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { Ng5SliderModule } from 'ng5-slider';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgxPrintModule } from 'ngx-print';

import { LandingRoutingModule } from './landing-routing.module';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';

import 'hammerjs';
import 'mousetrap';
import { FaqComponent } from './faq/faq.component';
import { ProdukComponent } from './produk/produk.component';
import { DocumentationApiComponent } from './documentation-api/documentation-api.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    NgbModule,
    CarouselModule,
    ArchwizardModule,
    NgxDatatableModule,
    NgSelectModule,
    GalleryModule.forRoot(),
    NgxPrintModule,
    Ng5SliderModule,
    Ng2SearchPipeModule,
    LandingRoutingModule
  ],
  declarations: [
    HomeComponent,
    AboutComponent,
    FaqComponent,
    ProdukComponent,
    DocumentationApiComponent
  ]
})
export class LandingModule { 
  
}
